/**
 * Draggable class events.
 */
export enum DraggableEvents {
  /**
   * Emitted on starting to drag.
   */
  DragStart = "drag-start",
  /**
   * Emitted on drag move updates.
   */
  DragMove = "drag-move",
  /**
   * Emitted on drag end.
   */
  DragEnd = "drag-end",
  /**
   * Emitted on drag end on a target position.
   */
  DragEndOnTarget = "drag-end-on-target",
  /**
   * Emitted after animation onto target position.
   */
  DragEndOnTargetStop = "drag-end-on-target-stop"
}
